function run_fit_vids(){
	$('iframe[src*="youtube"], iframe[src*="vimeo"]').parent().fitVids();
}

function close_nav(){
	$('body').removeClass('menu-open');	
	var targetElement = document.querySelector('.nav-wrap');
	bodyScrollLock.enableBodyScroll(targetElement);
}

$(document).ready( function() {
	run_fit_vids();

	$('body').on('click', function(e){
		if($(e.target).hasClass('menu-toggle')||$(e.target).parents('.menu-toggle').length) return;
		if($(this).hasClass('menu-open')){
			var targ = $(e.target);
			var in_nav = targ.parents('.nav-wrap').length || targ.hasClass('nav-wrap');
			if(!in_nav){
				e.preventDefault();
				close_nav();
			}
		}
	});

	
	// mobile menu nav handling
	$('.menu-toggle').on('click', function(){
		if($('body').hasClass('menu-open')){
			close_nav();
		} else{
			$('body').addClass('menu-open');
			var targetElement = document.querySelector('.nav-wrap');
			bodyScrollLock.disableBodyScroll(targetElement);			
		}
	});
	
	function close_dropdown(dropdown){
		dropdown.find("i.fa").toggleClass('fa-angle-up fa-angle-down');
		dropdown.children('.sub-menu').slideUp();
		dropdown.removeClass('active-menu');
	}
	function open_dropdown(dropdown){
		dropdown.siblings('.active-menu').each(function(i,v){
			close_dropdown($(v));
		});
		setTimeout(function(){
			dropdown.find("i.fa").addClass('fa-angle-up').removeClass('fa-angle-down');
			dropdown.children('.sub-menu').slideDown();
			dropdown.addClass('active-menu');			
		});
	}
	$('li.dropdown > a').on('click', function(e){
		e.preventDefault();
		var dropdown_item = $(this).parent('.dropdown');
		if(dropdown_item.hasClass('active-menu')){
			close_dropdown(dropdown_item);
			dropdown_item.parent('ul').removeClass('dropdown-active');
		} else {
			open_dropdown(dropdown_item);
			dropdown_item.parent('ul').addClass('dropdown-active');

		}
	});
	
	var minH = $(window).height() - ( $('header.banner').height() + $('footer').outerHeight());
	$('.wrap').css({minHeight:minH});

	if($('.hero-slider').length) {
		$('.hero-slider').slick({
			dots: true,
			arrows:false,
			infinite: true,
			speed: 200,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover:false,
			responsive: [
				{
					breakpoint: 650,
					settings: { 
						dots: false						
					}
				}
			]
		});
	}

	if($('.freshgrass-slider').length){
		$('.freshgrass-slider').slick({
			dots: false,
			arrows:false,
			infinite: true,
			speed: 200,
			fade: true,
			cssEase: 'linear',
			adaptiveHeight:true,
			pauseOnHover:true,
			autoplay: true,
			autoplaySpeed: 7500,
		});	
	}
	if($('.partners-slider').length){
		$('.partners-slider').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			dots: false,
			arrows:false,
			responsive: [
				{
					breakpoint: 1000,
					settings: {slidesToShow: 3}
				},
				{
					breakpoint: 500,
					settings: {slidesToShow: 2}
				}
			],
		});
	}
	
	// slick arrows
	$('.arrow-nav').on('click', function(e){
		e.preventDefault();
		var slider_selector = $(this).parents('.slider-nav').attr('data-slider');
		var action = $(this).hasClass('prev') ? 'slickPrev' : 'slickNext';
		$(slider_selector).slick(action);
	});
	

	
	$('.overlay-trigger').on('click', function(e){
		e.preventDefault();
		var overlay_id = $(this).attr('data-overlay');
		$('.overlay.active').removeClass('active');
		$('.overlay[data-overlay-id="'+overlay_id+'"]').addClass('active');
	});
	
	
	$('.artist-overlay-toggle').on('click', function(e){
		e.preventDefault();
		var href = $(this).attr('href');
		var slug = href.split('/artist/').slice(-1)[0].split('/')[0].split('?')[0];
		if(slug){
			var url = window.location.protocol + "//" + window.location.host + "/wp-json/artists/get/"+slug;
			$.getJSON(url, function(result){
				var artist_html = build_artist_overlay(result);
				$('.artist-overlay').find('.artist-content').html(artist_html)
				open_overlay('.artist-overlay')
			});
		}else{
			console.error("Can't find artist slug!");
		}
	});
	
	function open_overlay(selector){
		bodyScrollLock.disableBodyScroll($(selector).find('.overlay-container')[0]);
		$(selector).addClass('active');
	}
	$('.overlay-toggle.closer').on('click', function(e){
		e.preventDefault();
		bodyScrollLock.enableBodyScroll($(this).parents('.overlay').find('.overlay-container')[0]);
		$(this).parents('.overlay').removeClass('active');
	});
	
	function get_link_icon(type){
		var icon = 'fal fa-link';
		switch(type){
			case "facebook":
				icon ='fab fa-facebook-f';	
				break;
				
			case "twitter":
				icon ='fab fa-twitter';	
				break;
				
			case "instagram":
				icon ='fab fa-instagram';	
				break;
				
			case "youtube":
				icon ='fab fa-youtube';	
				break;
		}
		return icon;
	}
	function build_template(template_selector, vars){
		var template = $(template_selector).html();
		var keys = Object.keys(vars);
		console.log(keys);
		for(var i=0; i<keys.length; i++){
			template = template.replace(new RegExp("{{"+keys[i]+"}}", 'g'), vars[keys[i]]);
		}
		return template;
	}
	
	function build_artist_overlay(artist){
		artist.links_html = "";
		for(var i=0; i<artist.links.length; i++){
			vars = {
				href:artist.links[i].href,
				social:artist.links[i].type,
				artist_name:artist.name,
				icon_class:get_link_icon(artist.links[i].type),
			}
			artist.links_html += build_template('#artist-link-item', vars);
		}
		artist.image_type_class = artist.video_embed ? 'show-video' : 'show-image';
		var template = build_template('#artist-popup', artist);
		$('.overlay.artist-overlay').find('.artist-content').html(template);
		run_fit_vids();
	}

	
	$('.expander-title').on("click", function() {
		$(this).toggleClass('closer');
		$('.expander-content[data-expander-id='+$(this).attr('data-expander-id')+']').slideToggle();
	})

	$('.schedule-type-trigger').on('click', function(e){
		e.preventDefault();
		if(!$(this).hasClass('active')){
			var schedule_type = $(this).attr('data-scheudle');
			$('.schedule-type.active').removeClass('active');
			$('.schedule-type-trigger.active').removeClass('active');
			$('.schedule-type[data-schedule-type="'+schedule_type+'"]').addClass('active');
			$(this).addClass('active');
		}
		
		
	})
});
